import { render, staticRenderFns } from "./productBrand.vue?vue&type=template&id=1dd5740a&"
import script from "./productBrand.vue?vue&type=script&lang=js&"
export * from "./productBrand.vue?vue&type=script&lang=js&"
import style0 from "./productBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports